import * as React from "react";
import { CardHeader } from "reactstrap";

interface AntragHeaderProps {
    caption: string;
    logo: any;
    logoStyle?: any;
}

class AntragHeader extends React.Component<AntragHeaderProps, {}> {

  constructor(props:any) {
    super(props);

  }

render() {
    return (
        // <CardHeader>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'large'}}>
                    {this.props.caption}
                </div>
                <div>
                    {this.props.logo ?
                     <img src={this.props.logo} style={this.props.logoStyle} alt="logo" />
                     : null }
                </div>
            </div>
        // </CardHeader>
    );
  }
}

export default AntragHeader;
